import React, { useState, useEffect } from 'react'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { useAuth } from 'src/common/razzle-platform-user/Authentication'
import axios from 'src/common/razzle-platform-components/axios'
import { handleErrors } from 'src/common/razzle-platform-components/utils'
import { useAlert } from 'src/common/razzle-platform-components/alert'
import { useIntl } from 'src/common/razzle-platform-translate'
import ReservationPicker from './components/ReservationPicker'
import DefaultReservationButton from './components/DefaultReservationButton'
import {
	AVAILABILITIES_API_END_POINT,
	BASE_API_URL,
	BASE_URL,
    CART_ITEMS_API_END_POINT,
	RESERVATION_OPTION_UUID,
	RESERVATION_REDIRECT_AFTER_ADD_TO_SHPPING_CART_URL,
	OPTIONS_OF_PRODUCT_API_END_POINT
} from 'src/common/razzle-platform-reservation/configs'


function Reservation(props) {
	const locale = useSelector((state) => state.translationModel.locale)
	const { onAuth } = useAuth()
    const [isAddToCartItemRequestInProgress, setAddToCartItemRequestInProgress] = useState(false)
	const [availabilities, setAvailablities] = useState([])
	const [periodicities, setPeriodicities] = useState([])
    const {errorAlert, successAlert} = useAlert()
	const { formatMessage } = useIntl()
    const { product, confirmButton, displayDaysResult, indicators } = props

	useEffect(() => {
		if (_.isEmpty(availabilities)) {
            fetchAvailabilities()
		}
		if (_.isEmpty(periodicities)) {
			fetchPeriodicities()
		}
	}, [])

	const fetchAvailabilities = async () => {
		try {
			const params = {
				'product.id': product.id,
				geEndDate: moment().format('YYYY-MM-DD'),
				_embed: 'event.periodicity',
				_sort: 'start_date'
			}

			// set the Accept-Language to the headers of the request for get the translated data
			const headers = { "Accept-Language": locale }

			const response = await axios.get(`${BASE_API_URL}${AVAILABILITIES_API_END_POINT}`, { params, headers })
			setAvailablities(_.map(response.data, availability => ({
				id: availability.id,
				startDate: moment(availability.startDate, "YYYY-MM-DD HH:mm"),
				endDate: moment(availability.endDate, "YYYY-MM-DD HH:mm"),
				price: availability.event.price,
				isAvailable: availability.isAvailable,
				minPeriodicity: availability.event?.minPeriodicity,
				unit: availability.event?.periodicity.unit,
				unitNumbers: availability.event?.periodicity.unitNumbers,
				periodicityId: availability.event?.periodicity.id,
				label: availability.event?.periodicity.label,
				periodicityUuid: availability.event?.periodicity.uuid
			})))
		} catch (error) {
            errorAlert(handleErrors(error))
		}
	}

	const fetchPeriodicities = async () => {
		try {
			const params = {
				uuid: RESERVATION_OPTION_UUID,
				_embed:'periodicities'
			}

			// set the Accept-Language to the headers of the request for get the translated data
			const headers = { "Accept-Language": locale }

			const response = await axios.get(`${BASE_API_URL}${OPTIONS_OF_PRODUCT_API_END_POINT}`, {params, headers});
			setPeriodicities(response.data[0].periodicities)
		} catch (error) {
            errorAlert(handleErrors(error))
		}
	}

	const addToShoppingCart = async (data) => {
        setAddToCartItemRequestInProgress(true)
        try {
			const linkedOptionIndex = 10000
			const model = {
				salableItemClass: 'InternalSalableProduct',
				salableItemUuid: product.uuid,
			}
			_.forEach(data, (item, index) => {
				const { startDate, numPeriodicity, periodicity, ...extraData } = item
				model[`optionsLinkedToCartItem-${linkedOptionIndex + index}-optionClass`] = 'OptionOfProduct'
				model[`optionsLinkedToCartItem-${linkedOptionIndex + index}-optionUuid`] = RESERVATION_OPTION_UUID
				model[`optionsLinkedToCartItem-${linkedOptionIndex + index}-extraData`] = JSON.stringify({
					num_periodicity: numPeriodicity,
					start_date: startDate,
					periodicity,
					...extraData,
				})
			})
			await axios.post(`${BASE_API_URL}${CART_ITEMS_API_END_POINT}`, model)
			if (props.afterReserved) {
				props.afterReserved()
			} else {
				window.location.href = RESERVATION_REDIRECT_AFTER_ADD_TO_SHPPING_CART_URL || `${BASE_URL}app/cart`
			}
            successAlert(formatMessage({ id: 'Votre demande a été éffectuée.', defaultMessage: 'Votre demande a été éffectuée.' }))
		} catch (error) {
            errorAlert(handleErrors(error))
        }
        setAddToCartItemRequestInProgress(false)
	}

    const ReservationButton = props.reservationButton || DefaultReservationButton

	return (
		<ReservationPicker
			availabilities={availabilities}
			periodicities={periodicities}
			onConfirm={(data) => onAuth((usr) => {usr.id !== product?.user?.id && addToShoppingCart(data)})}
			inProgress={isAddToCartItemRequestInProgress}
			indicators={indicators}
			displayDaysResult={displayDaysResult}
			confirmButton={confirmButton}
			reservationButton={ReservationButton}
		/>
	)

}

export default Reservation
